import React, { lazy, Suspense } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { history } from "@/store";
import { Layout, Spinner } from "@/components";
import App from "@/App";

import adminRoutes from "./admin";
import mainOrgRoutes from "./mainOrg";

const Login = lazy(() => import("@/pages/Auth/Login"));
const Forgot = lazy(() => import("@/pages/Auth/Forgot"));
const Unlock = lazy(() => import("@/pages/Auth/Unlock"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const fallback = <div className="loading-bar loading-bar--fixed" />;

export default function Routes() {
  const isMainOrganization = useSelector(
    (state) => state.auth.is_main_organization,
  );

  return (
    <Router history={history}>
      <App>
        {({ isFetched, isAuthenticated, user }) => {
          if (!isFetched) {
            return <Spinner position="full" />;
          }

          if (!isAuthenticated) {
            return (
              <Suspense fallback={fallback}>
                <Switch>
                  <Route path="/" component={Login} exact />
                  <Route path="/forgot" component={Forgot} exact />
                  <Route path="/unlock" component={Unlock} exact />
                  <Redirect from="*" to="/" />
                </Switch>
              </Suspense>
            );
          }

          const role = get(user, "role.role");
          const activeRoutes = isMainOrganization ? mainOrgRoutes : adminRoutes;

          return (
            <Layout>
              <Suspense fallback={fallback}>
                <Switch>
                  {role === "admin" &&
                    activeRoutes.map((route) => (
                      <Route
                        key={route.path}
                        path={route.path}
                        component={route.component}
                        exact
                      />
                    ))}
                  <Route path="*" component={NotFound} exact />
                </Switch>
              </Suspense>
            </Layout>
          );
        }}
      </App>
    </Router>
  );
}
